import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/theme/liga-logo-white.png'


const _hoisted_1 = ["src", "type"]
const _hoisted_2 = {
  key: 0,
  class: "video-grid"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "video-thumbnail" }
const _hoisted_5 = { class: "play-overlay" }
const _hoisted_6 = { class: "video-info" }
const _hoisted_7 = { class: "video-title" }
const _hoisted_8 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_9 = {
  key: 0,
  class: "video-grid"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "video-thumbnail" }
const _hoisted_12 = { class: "play-overlay" }
const _hoisted_13 = { class: "video-info" }
const _hoisted_14 = { class: "video-title" }
const _hoisted_15 = {
  key: 1,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _cache[18] || (_cache[18] = _createElementVNode("h1", { class: "header-title ion-text-center white-bold" }, " Образование ", -1)),
          _withDirectives(_createElementVNode("div", {
            class: "video-overlay",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.exitVideoPlayer && _ctx.exitVideoPlayer(...args)))
          }, [
            _createElementVNode("div", {
              class: "video-container",
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("button", {
                class: "close-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exitVideoPlayer && _ctx.exitVideoPlayer(...args)))
              }, [
                _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
              ]),
              _createElementVNode("video", {
                ref: "videoPlayer",
                oncontextmenu: "return false;",
                preload: "auto",
                autoPictureInPicture: "true",
                playsinline: "",
                "webkit-playsinline": "",
                "x-webkit-airplay": "allow",
                controls: "",
                crossorigin: "anonymous",
                onLoadedmetadata: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onVideoLoaded && _ctx.onVideoLoaded(...args))),
                onWaiting: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onVideoWaiting && _ctx.onVideoWaiting(...args))),
                onPlaying: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onVideoPlaying && _ctx.onVideoPlaying(...args))),
                onPause: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onVideoPaused && _ctx.onVideoPaused(...args))),
                onEnded: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onVideoEnded && _ctx.onVideoEnded(...args))),
                onError: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onVideoError && _ctx.onVideoError(...args)))
              }, [
                _createElementVNode("source", {
                  src: _ctx.trackPath,
                  type: _ctx.trackPath.endsWith('m3u8')
                ? 'application/x-mpegURL'
                : 'video/mp4'
                
                }, null, 8, _hoisted_1)
              ], 544)
            ])
          ], 512), [
            [_vShow, _ctx.showVideoPlayer]
          ]),
          _withDirectives(_createVNode(_component_ion_segment, {
            modelValue: _ctx.selectedListSegment,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedListSegment) = $event)),
            mode: "md",
            class: "custom-segment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_segment_button, { value: "all" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("Общие", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_segment_button, { value: "academia" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("Академия", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]), [
            [_vShow, _ctx.hasAcademia]
          ]),
          _createVNode(_component_ion_content, {
            class: "list-content",
            "scroll-y": true
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_ion_refresher, {
                  slot: "fixed",
                  onIonRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.reloadSkills($event)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_refresher_content, { refreshingSpinner: "bubbles" })
                  ]),
                  _: 1
                }),
                (_ctx.videoList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (video) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: video.id,
                          class: "video-card",
                          onClick: ($event: any) => (_ctx.selectVideo(video.id))
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              (video.id !== _ctx.selectedId || !_ctx.videoLoading)
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 0,
                                    icon: _ctx.play
                                  }, null, 8, ["icon"]))
                                : (_openBlock(), _createBlock(_component_ion_spinner, {
                                    key: 1,
                                    name: "bubbles"
                                  }))
                            ]),
                            _cache[14] || (_cache[14] = _createElementVNode("img", {
                              src: _imports_0,
                              alt: "liga-logo",
                              class: "video-logo"
                            }, null, -1))
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.formatVideoTitle(video.name)), 1)
                          ])
                        ], 8, _hoisted_3))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("p", null, "Нет доступных видео", -1)
                    ]))]))
              ], 512), [
                [_vShow, _ctx.selectedListSegment === 'all']
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_ion_refresher, {
                  slot: "fixed",
                  onIonRefresh: _cache[11] || (_cache[11] = ($event: any) => (_ctx.reloadSkills($event)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_refresher_content, { refreshingSpinner: "bubbles" })
                  ]),
                  _: 1
                }),
                (_ctx.academiaVideoList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.academiaVideoList, (video) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: video.id,
                          class: "video-card",
                          onClick: ($event: any) => (_ctx.selectVideo(video.id))
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              (video.id !== _ctx.selectedId || !_ctx.videoLoading)
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 0,
                                    icon: _ctx.play
                                  }, null, 8, ["icon"]))
                                : (_openBlock(), _createBlock(_component_ion_spinner, {
                                    key: 1,
                                    name: "bubbles"
                                  }))
                            ]),
                            _cache[16] || (_cache[16] = _createElementVNode("img", {
                              src: _imports_0,
                              alt: "liga-logo",
                              class: "video-logo"
                            }, null, -1))
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.formatVideoTitle(video.name)), 1)
                          ])
                        ], 8, _hoisted_10))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("p", null, "Нет доступных видео", -1)
                    ]))]))
              ], 512), [
                [_vShow, _ctx.selectedListSegment === 'academia']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}